import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { onAuthStateChanged } from "firebase/auth";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import "./index.css";
import App from "./App";
import theme from "./theme";
import { authStateChanged } from "./features/authSlice";
import { auth } from "./firebaseConfig";
import { store } from "./store";

onAuthStateChanged(auth, (user) => {
  store.dispatch(authStateChanged(user));
});

const paypalOptions = {
  clientId:
    "AfieAStpn16JYoYysF_WWiEIC3SaGq8vskfD3PMvXxnUlNsSyI2HyEeXo6fe_W308awTB0CWeudB3COg",
  disableFunding: ["paylater", "venmo"],
  intent: "capture",
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PayPalScriptProvider options={paypalOptions}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Provider store={store}>
          <App />
        </Provider>
      </ThemeProvider>
    </PayPalScriptProvider>
  </React.StrictMode>,
);
